/**
 * Kind → content-body registry. The frame (EventBlock) resolves one component
 * here and renders it; no per-type conditionals live in JSX anywhere.
 *
 * Extension rule (open/closed): a new event kind means a new component file
 * plus one entry below — existing components are never edited for it.
 */
import React from "react";
import { MCEventKind } from "../model/eventKind";
import { MCEventContentProps } from "./parts";
import AppointmentContent from "./AppointmentContent";
import GroupContent from "./GroupContent";
import { AbsenceContent, BreakContent, GenericContent, TravelContent } from "./structural";

const EVENT_CONTENT_BY_KIND: Record<MCEventKind, React.ComponentType<MCEventContentProps>> = {
  appointment: AppointmentContent,
  group: GroupContent,
  break: BreakContent,
  travel: TravelContent,
  absence: AbsenceContent,
  draft: AppointmentContent,
  generic: GenericContent,
};

export const contentForKind = (
  kind: MCEventKind,
): React.ComponentType<MCEventContentProps> =>
  EVENT_CONTENT_BY_KIND[kind] ?? GenericContent;

export type { MCEventContentProps } from "./parts";
